import React, { useState } from 'react';

const TestConnection = () => {
  const [testResult, setTestResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const testApiConnection = async () => {
    setIsLoading(true);
    setTestResult(null);
    
    try {
      // Probar conexión básica
      const response = await fetch('http://localhost:3003/health');
      const data = await response.json();
      
      if (response.ok) {
        setTestResult({
          success: true,
          message: 'Conexión API exitosa',
          data: data
        });
      } else {
        setTestResult({
          success: false,
          message: 'Error en respuesta API',
          error: `Status: ${response.status}`
        });
      }
    } catch (error) {
      setTestResult({
        success: false,
        message: 'Error de conexión',
        error: error.message
      });
    } finally {
      setIsLoading(false);
    }
  };

  const testGoogleAuth = async () => {
    setIsLoading(true);
    setTestResult(null);
    
    try {
      // Probar endpoint de Google Auth con datos de prueba
      const testData = {
        id: 'test123',
        name: 'Usuario de Prueba',
        email: 'test@example.com',
        picture: 'https://example.com/avatar.jpg',
        accessToken: 'test_token',
        refreshToken: null
      };
      
      const response = await fetch('http://localhost:3003/api/auth/google', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(testData)
      });
      
      const data = await response.json();
      
      setTestResult({
        success: response.ok,
        message: response.ok ? 'Endpoint Google Auth funcional' : 'Error en Google Auth',
        data: data,
        status: response.status
      });
    } catch (error) {
      setTestResult({
        success: false,
        message: 'Error probando Google Auth',
        error: error.message
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{
      padding: '20px',
      margin: '20px',
      border: '1px solid #ddd',
      borderRadius: '8px',
      backgroundColor: '#f9f9f9'
    }}>
      <h2>🔧 Test de Conexión API</h2>
      
      <div style={{ marginBottom: '20px' }}>
        <button 
          onClick={testApiConnection}
          disabled={isLoading}
          style={{
            padding: '10px 20px',
            marginRight: '10px',
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: isLoading ? 'not-allowed' : 'pointer'
          }}
        >
          {isLoading ? 'Probando...' : 'Probar Conexión API'}
        </button>
        
        <button 
          onClick={testGoogleAuth}
          disabled={isLoading}
          style={{
            padding: '10px 20px',
            backgroundColor: '#2196F3',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: isLoading ? 'not-allowed' : 'pointer'
          }}
        >
          {isLoading ? 'Probando...' : 'Probar Google Auth Endpoint'}
        </button>
      </div>

      {testResult && (
        <div style={{
          backgroundColor: testResult.success ? '#e8f5e8' : '#ffebee',
          padding: '15px',
          borderRadius: '4px',
          marginTop: '20px'
        }}>
          <h3>{testResult.success ? '✅' : '❌'} Resultado:</h3>
          <p><strong>Mensaje:</strong> {testResult.message}</p>
          
          {testResult.status && (
            <p><strong>Status:</strong> {testResult.status}</p>
          )}
          
          {testResult.data && (
            <div>
              <p><strong>Datos:</strong></p>
              <pre style={{ 
                backgroundColor: '#f5f5f5', 
                padding: '10px', 
                borderRadius: '4px',
                fontSize: '12px',
                overflow: 'auto'
              }}>
                {JSON.stringify(testResult.data, null, 2)}
              </pre>
            </div>
          )}
          
          {testResult.error && (
            <p style={{ color: '#d32f2f' }}><strong>Error:</strong> {testResult.error}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default TestConnection;